import {
  StackSeparator,
  Text,
  Stack,
  HStack,
  Portal,
  Toaster as ChakraToaster,
  Toast,
  createToaster,
} from "@chakra-ui/react";
import { t } from "i18next";
import { NotificationItem } from "./NotificationItem";
import { InfoOutlineIcon } from "../../shared/views/icons";

export const newNotificationToaster = createToaster({
  placement: "bottom-end",
  pauseOnPageIdle: true,
});

export const NewNotificationToaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={newNotificationToaster} insetInline={{ mdDown: "4" }}>
        {(toast) => (
          <Toast.Root width={{ md: "sm" }}>
            <Toast.Indicator />

            <Stack w="400px" separator={<StackSeparator />}>
              <Toast.Title>
                <HStack>
                  <InfoOutlineIcon />
                  <Text fontSize="sm">{t(`notification:newToast`)}</Text>
                </HStack>
              </Toast.Title>

              <Toast.Description>
                <NotificationItem
                  notification={toast.description as any}
                  onAction={() => {
                    newNotificationToaster.dismiss();
                  }}
                />
              </Toast.Description>
            </Stack>

            {toast.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
